import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DevicesService } from '../../services/devices.service';
import { UsersService } from '../../services/users.service';
import { LoginUserModel } from '../../models/loginUserModel';
import { UserOtp } from '../../models/UserOtp';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DriverModel } from '../../models/DriverModel';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { environment } from '../../../environments/environment';
import { LoaderComponent } from '../../utils/loader/loader.component';
import { AvatarComponent } from '../../utils/avatar/avatar.component';
import { ToastService } from '../../services/toast.service';
import { FileStorageService } from '../../services/file-storage.service';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { TooltipModule } from 'primeng/tooltip';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-drivers',
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, NgxMaskDirective,
    LoaderComponent, AvatarComponent,
    TableModule, ButtonModule, InputTextModule, DialogModule, ImageCropperComponent,
    IconFieldModule, InputIconModule, TooltipModule
  ],
  templateUrl: './drivers.component.html',
  styleUrl: './drivers.component.scss',
  providers: [provideNgxMask()]
})
export class DriversComponent {
  loading = true;
  isButtonOTP = false;
  showLadaList = false;
  show2FA = false;
  isPhoneAuth = false;
  selectedLada = '+52';
  showMessageError = false;
  messageError = '';
  prevPhone = '';
  messageLoader = 'Cargando conductores';
  drivers: any[] = [];
  formDriver!: FormGroup;
  isEditing = false;
  showFormDialog = false;
  driverPhotoUrl: any = null;
  driverPhotoFileId: string | null = null;
  showCropper = false;
  imageChangedEvent: any = null;
  selectedDrivers: any[] = [];
  selectedDriver: any;
  data!: LoginUserModel;
  globalFilter = '';

  pattern = { K: { pattern: new RegExp('[A-Za-z0-9- ]'), optional: true } };

  get isAdmin() { return this.data.UserType === 'Administrator' || this.data.UserType === 'Modify'; }
  get userName() { return this.data.UserType === 'Administrator' ? 'Administrador de la cuenta' : this.data.Name; }
  get phone() { return this.formDriver.get('phoneNumber') as FormControl; }
  get driverName() { return this.formDriver.get('driverName') as FormControl; }

  constructor(
    private service: DevicesService,
    private userService: UsersService,
    private titleService: Title,
    private themeService: ThemeService,
    private toastSrv: ToastService, private fileStorage: FileStorageService, private sanitizer: DomSanitizer
  ) {
    this.titleService.setTitle('Conductores');
    this.themeService.setTitle('Conductores');
    this.data = JSON.parse(localStorage.getItem('data')!);
  }

  ngOnInit() {
    this.loadDrivers();
    this.formDriver = new FormGroup({
      driverName: new FormControl('', Validators.required),
      phoneNumber: new FormControl('', [Validators.required, this.validateUniquePhone(0)]),
    });
  }

  // --- CRUD ---

  loadDrivers() {
    this.loading = true;
    this.service.getDrivers(this.data.Client_number).subscribe({
      next: (resp: any) => {
        this.drivers = resp.map((item: any) => ({ ...item, type: 0, photo_uuid: item.file_image_id || null }));
        this.loading = false;
      },
      error: () => { this.drivers = []; this.loading = false; }
    });
  }

  onPhotoSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    this.imageChangedEvent = event;
    this.showCropper = true;
    setTimeout(() => { input.value = ''; }, 100);
  }

  imageCropped(event: ImageCroppedEvent) {
    const base64 = event.base64!;
    this.driverPhotoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(base64);
    this.fileStorage.uploadBase64Image(base64, 'driver_' + Date.now() + '.png', 'portal-drivers').subscribe({
      next: (fileId) => {
        this.driverPhotoFileId = fileId;
        this.toastSrv.add({ type: 'success', message: 'Foto cargada' });
      },
      error: () => this.toastSrv.add({ type: 'error', message: 'Error al subir foto' })
    });
  }

  doCrop(cropper: any) {
    cropper.crop();
    this.showCropper = false;
    this.imageChangedEvent = null;
  }

  openNew() {
    this.isEditing = false;
    this.driverPhotoUrl = null;
    this.driverPhotoFileId = null;
    this.selectedDriver = null;
    this.formDriver.reset();
    this.phone.enable();
    this.selectLada('+52');
    this.isPhoneAuth = false;
    this.isButtonOTP = false;
    this.showFormDialog = true;
  }

  openEdit(driver: any) {
    this.isEditing = true;
    this.selectedDriver = driver;
    this.phone.clearValidators();
    this.phone.addValidators([Validators.required, this.validateUniquePhone(driver.driver_id)]);
    this.phone.disable();
    this.isPhoneAuth = true;
    this.isButtonOTP = true;
    this.prevPhone = driver.phone_number.includes(' ') ? driver.phone_number.split(' ')[1] : driver.phone_number;
    this.selectLada(driver.phone_number.includes(' ') ? driver.phone_number.split(' ')[0] : '+52');
    this.driverName.setValue(driver.name);
    this.phone.setValue(this.prevPhone);
    this.showFormDialog = true;
  }

  addDriver() {
    if (!this.formDriver.valid || !this.isPhoneAuth) return;
    const info: DriverModel = {
      driver_id: this.selectedDriver?.driver_id || 0,
      client_id: this.selectedDriver?.client_id || this.data.Client_id,
      card_id: 0,
      name: this.driverName.value,
      phone_number: this.selectedLada.split('+')[1] + ' ' + this.phone.value,
      user_name: this.userName,
      // photo_uuid: null, // TODO: implement photo upload with ngx-image-cropper + FileStorageService
    };
    this.saving = true;
    this.service.addDriver(info, this.data.Client_number).subscribe({
      next: (resp: any) => {
        this.saving = false;
        this.showFormDialog = false;
        if (resp) {
          const driverId = resp.driverId || this.selectedDriver?.driver_id;
          if (this.driverPhotoFileId && driverId) {
            this.service.saveDriverPhoto(driverId, this.data.Client_number, this.driverPhotoFileId).subscribe();
          }
          this.toastSrv.add({ type: 'success', message: this.isEditing ? 'Conductor actualizado' : resp.message || 'Conductor agregado' });
          this.loadDrivers();
        } else {
          this.toastSrv.add({ type: 'error', message: 'Error al guardar el conductor' });
        }
      },
      error: () => { this.saving = false; this.toastSrv.add({ type: 'error', message: 'Error al guardar el conductor' }); }
    });
  }

  saving = false;
  showDeleteConfirm = false;
  deleteTarget: any = null;

  confirmDelete(driver: any) {
    this.deleteTarget = driver;
    this.showDeleteConfirm = true;
  }

  deleteDriver() {
    this.showDeleteConfirm = false;
    this.selectedDriver = this.deleteTarget;
    this.loading = true;
    this.messageLoader = 'Eliminando';
    const info: DriverModel = {
      driver_id: this.selectedDriver.driver_id,
      client_id: this.selectedDriver.client_id,
      card_id: 0, name: this.selectedDriver.name,
      phone_number: this.selectedDriver.phone_number,
      user_name: this.userName,
    };
    this.service.deleteDriver(info, this.data.Client_number).subscribe({
      next: (resp: any) => {
        this.loading = false;
        if (resp) { this.toastSrv.add({ type: 'success', message: info.name + ' eliminado' }); this.loadDrivers(); }
        else { this.toastSrv.add({ type: 'error', message: 'Error al eliminar' }); }
      },
      error: () => { this.loading = false; this.toastSrv.add({ type: 'error', message: 'Error al eliminar' }); }
    });
  }

  deleteSelected() {
    this.loading = true;
    this.messageLoader = 'Eliminando';
    const request = this.selectedDrivers.map(d => ({
      driver_id: d.driver_id, client_id: d.client_id, card_id: 0,
      name: d.name, phone_number: d.phone_number, user_name: this.userName,
    }));
    this.service.deleteDrivers(request, this.data.Client_number).subscribe({
      next: (resp: any) => {
        this.loading = false;
        this.selectedDrivers = [];
        if (resp.isSuccess) { this.toastSrv.add({ type: 'success', message: 'Conductores eliminados' }); this.loadDrivers(); }
        else { this.toastSrv.add({ type: 'error', message: 'Error al eliminar' }); }
      },
      error: () => { this.loading = false; this.toastSrv.add({ type: 'error', message: 'Error al eliminar' }); }
    });
  }

  resend(driver: any) {
    this.loading = true;
    this.messageLoader = 'Enviando correo';
    this.service.resendEmail(driver).subscribe({
      next: () => { this.loading = false; this.toastSrv.add({ type: 'success', message: 'Correo de activación reenviado' }); },
      error: () => { this.loading = false; this.toastSrv.add({ type: 'error', message: 'Error al reenviar' }); }
    });
  }

  showOtpInput = false;
  sendingOtp = false;
  otpError = '';
  otpTimer = 0;
  private otpInterval: any;
  private otpCode = '';

  // --- Phone OTP ---

  onInputPhone(event: any) {
    if (this.isEditing) {
      this.isPhoneAuth = this.prevPhone === this.phone.value;
      this.isButtonOTP = this.isPhoneAuth;
      if (this.isPhoneAuth) this.showOtpInput = false;
    }
    // Auto-send OTP when 10 digits entered
    const raw = this.phone.value?.replace(/\D/g, '') || '';
    if (raw.length === 10 && !this.isPhoneAuth && this.phone.valid) {
      this.validateSendOTPCode();
    }
  }

  validateSendOTPCode() {
    this.sendingOtp = true;
    this.otpError = '';
    if (!this.phone.valid) { this.messageError = 'Teléfono no válido'; this.showMessageError = true; this.sendingOtp = false; return; }

    
    const otp = new UserOtp();
    otp.dialCode = this.selectedLada.split('+')[1];
    otp.phoneNumber = this.phone.value;
    otp.clientNumber = this.data.Client_number;
    this.userService.validatePhoneNumber(otp.clientNumber, otp.phoneNumber, 4, otp.dialCode).subscribe({
      next: (data: any) => {
        this.sendingOtp = false;
        if (data.msg) { this.showOtpInput = true; this.startOtpTimer(); }
        else { this.otpError = data.error; this.showOtpInput = false; }
      },
      error: (err: any) => { this.sendingOtp = false; this.otpError = err; }
    });
  }

  resendOtp() { this.validateSendOTPCode(); }

  onOtpKeyUp(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value && index < 3) {
      document.getElementById('otp_' + (index + 1))?.focus();
    }
    if (event.key === 'Backspace' && !value && index > 0) {
      document.getElementById('otp_' + (index - 1))?.focus();
    }
    this.checkOtpComplete();
  }

  onOtpPaste(event: ClipboardEvent) {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text')?.replace(/\D/g, '') || '';
    for (let i = 0; i < 4 && i < paste.length; i++) {
      const el = document.getElementById('otp_' + i) as HTMLInputElement;
      if (el) el.value = paste[i];
    }
    this.checkOtpComplete();
  }

  private checkOtpComplete() {
    let code = '';
    for (let i = 0; i < 4; i++) {
      const el = document.getElementById('otp_' + i) as HTMLInputElement;
      code += el?.value || '';
    }
    if (code.length === 4) {
      this.otpCode = code;
      this.verifyOtpCode(code);
    }
  }

  private verifyOtpCode(code: string) {
    this.userService.validateOTPCode(code, this.data.Client_number, this.data.User_id, 4, this.phone.value).subscribe({
      next: (resp: any) => {
        if (resp.isSuccess) { this.onOtpVerified(); }
        else { this.otpError = resp.message || 'Código incorrecto'; }
      },
      error: () => { this.otpError = 'Error al verificar código'; }
    });
  }

  private onOtpVerified() {
    this.show2FA = false;
    this.showOtpInput = false;
    this.phone.disable();
    this.isButtonOTP = true;
    this.isPhoneAuth = true;
    clearInterval(this.otpInterval);
  }

  private startOtpTimer() {
    this.otpTimer = 30;
    clearInterval(this.otpInterval);
    this.otpInterval = setInterval(() => {
      this.otpTimer--;
      if (this.otpTimer <= 0) clearInterval(this.otpInterval);
    }, 1000);
  }

  validateOTP(code: any) { this.onOtpVerified(); }

  toggleLadaList() { this.showLadaList = !this.showLadaList; }
  selectLada(lada: string) { this.selectedLada = lada.split(' ')[0]; this.showLadaList = false; }

  validateUniquePhone(driverId: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phone = control.value;
      const exists = this.drivers.find(d => (d.phone_number.includes(' ') ? d.phone_number.split(' ')[1] : d.phone_number) === phone && d.driver_id !== driverId);
      return exists ? { duplicate: true } : null;
    };
  }

  selectDriver(event: any) { this.selectedDrivers = event.filter((i: any) => i.type === 2); }

  isActive(driver: any) { return new Date(driver.validFrom) <= new Date(); }
}
